import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";

export default function HelperTooltip({ tooltipText }) {
  return (
    <Tooltip title={tooltipText}>
      <HelpOutlineIcon
        color="disabled"
        fontSize="small"
        style={{ margin: "auto 4px", fontSize: 18 }}
      />
    </Tooltip>
  );
}
